import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="bru-card px-6 py-4">
          <p className="tag-label">Caricamento…</p>
        </div>
      </div>
    );
  }
  if (!user) {
    const next = location.pathname + location.search;
    const qs = next && next !== "/" ? `?next=${encodeURIComponent(next)}` : "";
    return <Navigate to={`/login${qs}`} replace state={{ from: location }} />;
  }
  return children;
}
